import React, { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const AddNewTMapMetadata = ({ getStudyCDISCTMap, studyId }) => {
  const [domain, setDomain] = useState("");
  const [pattern, setPattern] = useState("");
  const [testCD, setTestCD] = useState("");
  const [testName, setTestName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewStudyCDISCTMap = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.domain = domain;
    userData.pattern = pattern;
    userData.testCD = testCD;
    userData.testName = testName;
    let data = await cdiscManagementService.addNewStudyCDISCTMap(userData);
    if (data?.statusCode === 200) {
      getStudyCDISCTMap();
      setDomain("");
      setPattern("");
      setTestCD("");
      setTestName("");
    }
    setButtonLoader(false);
  };

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Domain <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          required
          type="text"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          placeholder="Enter Domain"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">Pattern</Form.Label>
        <Form.Control
          type="text"
          value={pattern}
          onChange={(e) => setPattern(e.target.value)}
          placeholder="Enter Pattern "
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">Test CD</Form.Label>
        <Form.Control
          type="text"
          value={testCD}
          onChange={(e) => setTestCD(e.target.value)}
          placeholder="Enter TestCD"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">Test Name</Form.Label>
        <Form.Control
          type="text"
          value={testName}
          onChange={(e) => setTestName(e.target.value)}
          placeholder="Enter Test Name"
        />
      </Form.Group>
      <Form.Group className="text-end">
        <button
          disabled={buttonLoader || !domain}
          onClick={addNewStudyCDISCTMap}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add TMap"
          )}
        </button>
      </Form.Group>
    </div>
  );
};

export default AddNewTMapMetadata;
